import { render, staticRenderFns } from "./achievementDetail.vue?vue&type=template&id=e8c87b6c&scoped=true"
import script from "./achievementDetail.vue?vue&type=script&lang=js"
export * from "./achievementDetail.vue?vue&type=script&lang=js"
import style0 from "./achievementDetail.vue?vue&type=style&index=0&id=e8c87b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c87b6c",
  null
  
)

export default component.exports